export const getXmlObject = (content: string): any => {
  const parser = new DOMParser();
  return parser.parseFromString(content, 'application/xml');
};

/**
 * Checks if provided object is xml.
 * @param content
 */
export const isXmlString = (content: string) => {
  const domObj = getXmlObject(content);
  return domObj.getElementsByTagName('parsererror').length === 0;
};

/**
 * Utility function which gets namespace value from XML string.
 * @param xmlString
 */
export const extractNameSpaceFromXmlString = (xmlString: string): { [key: string]: string } => {
  // Create a DOMParser instance and parse the XML string
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlString, 'text/xml');

  // Define an object to store the namespaces
  const namespaces: { [key: string]: string } = {};

  // Function to recursively traverse the DOM tree and extract namespaces
  function extractNamespaces(element: Element) {
    // Get the element's attributes
    const attributes = element.attributes;

    // Iterate through the attributes to find namespace declarations
    for (let i = 0; i < attributes.length; i++) {
      const attr = attributes[i];

      // Check if the attribute is a namespace declaration
      if (attr.prefix === 'xmlns') {
        namespaces[attr.localName] = attr.value;
      }
    }

    // Recursively process child elements
    for (let i = 0; i < element.childNodes.length; i++) {
      const child = element.childNodes[i];
      if (child.nodeType === Node.ELEMENT_NODE) {
        // Process only element nodes
        extractNamespaces(child as Element);
      }
    }
  }

  // Start the extraction by calling the function on the root element
  extractNamespaces(xmlDoc.documentElement);
  return namespaces;
};
